export { default } from './GuideSidebarFooter';
